export default function ({ app, $auth, route }) {
  $auth.onRedirect((to) => {
    let nextPage = to.fullPath
    if (route.path !== '/auth/login') {
      nextPage = `${app.$routeName.login}?redirect_url=${route.fullPath}`
      return nextPage
    }
    return nextPage
  })
}
